export const mainRouteInitial ="Nighteye"